import { z } from "zod";

import {
  OrgContactSchema,
  OrgInvitationSchema,
  OrgMemberRoleSchema,
  OrgSchema,
  UserSchema
} from "../../models";

export const OrgInvitationDetailSchema = OrgInvitationSchema.extend({
  org: OrgSchema.extend({ contact: OrgContactSchema }),
  invitedBy: UserSchema
});
export type OrgInvitationDetail = z.infer<typeof OrgInvitationDetailSchema>;

export const SendOrgInvitationRequestSchema = z.object({
  email: z.string().email(),
  role: OrgMemberRoleSchema
});
export type SendOrgInvitationRequest = z.infer<typeof SendOrgInvitationRequestSchema>;
